import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import EmailReceptionPage from "../views/EmailReception.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    props: true
  },
  // URL 'jeton', version française
  {
    path: "/jeton/:jeton",
    name: "EmailValidationFr",
    component: EmailReceptionPage,
    props: { origin: 'validationCourriel', langSelected: 'fr' }
  },
  // URL 'jeton', version anglaise : token
  {
    path: "/token/:jeton",
    name: "EmailValidationEn",
    component: EmailReceptionPage,
    props: { origin: 'validationCourriel', langSelected: 'en' }
  },
  // URL 'enrichissement', version française
  {
    path: "/enrichissement/:jeton",
    name: "EditFormFr",
    component: EmailReceptionPage,
    props: { origin: 'enrichissementForm', langSelected: 'fr' }
  },
  // URL 'enrichissement', version anglaise : edit
  {
    path: "/edit/:jeton",
    name: "EditFormEn",
    component: EmailReceptionPage,
    props: { origin: 'enrichissementForm', langSelected: 'en' }
  },
  {
    path: "/demande-personnelle",
    name: "demande-personnel",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "Formulaire personnel" */ "./../views/FormUser.vue"
      )
  },
  {
    path: "/demande-organisme",
    name: "demande-organisme",
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "Formulaire organisme" */ "./../views/FormOrga.vue"
      )
  },
  {
    path: "/merci",
    name: "Merci",
    props: true,
    component: () =>
      import(/* webpackChunkName: "Merci" */ "./../views/Merci.vue")
  },
  {
    path: "/attente-validation-courriel",
    name: "emailValidationSent",
    props: true,
    component: () =>
      import(/* webpackChunkName: "Merci" */ "./../views/EmailValidationSent.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
